module.exports = __webpack_public_path__ + "img/icon12.e4cc81c7.png";